var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Cadastro"}},[_c('router-view',{on:{"fire-toast":_vm.handleToast,"muda-parcela":_vm.mudaParcela}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }